module.exports = "/packs/payment-schedule-image-sp-55ce81925fb6402ca13b3e94996b5a7d.png";